<template>
  <div>
    <CustomAlert
      >We're sorry that you've encountered technical difficulty with your lab.
      Please describe in detail what you have encountered so we can verify and
      reproduce the error. The support team will get back to you within one
      business day.</CustomAlert
    >
    <form @submit.prevent="submitForm">
      <textarea
        class="form-control"
        rows="3"
        v-model="feedback"
        placeholder="Describe the issue"
        required
      ></textarea>
      <div class="text-end">
        <button type="submit" class="btn btn-primary mt-3 fw-bold">
          Contact Support
        </button>
      </div>
    </form>
    <pre class="text-start d-none">{{ payload }}</pre>
  </div>
</template>

<script>
import CustomAlert from "@/components/ui/CustomAlert.vue";
import store from "@/store";
import axios from "axios";
export default {
  name: "SupportForm",
  components: {
    CustomAlert
  },
  data() {
    return {
      feedback: ""
    };
  },
  computed: {
    payload() {
      const url = `${process.env.VUE_APP_DEPLOY_BUCKET}/${process.env.VUE_APP_DEPLOY_PATH}`;

      let navigator = window?.navigator;

      return {
        userAgent: navigator?.userAgent,
        mobile: navigator?.userAgentData?.mobile,
        platform: navigator?.userAgentData?.platform,
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        lab: process.env.VUE_APP_TITLE,
        url,
        section: url.includes("-400") ? "400" : "401",
        name: store.getters.getFullname,
        onid: store.getters.getOnid,
        feedback: this.feedback
      };
    }
  },
  methods: {
    submitForm() {
      this.$emit("submitted");
      return this.axiosCall(this.payload);
    },
    async axiosCall(payload) {
      const url = "https://api.oregonstate.education/support/v1/issue";
      return axios({
        method: "POST",
        url: url,
        data: payload,
        headers: {
          Authorization: `Bearer ${store.getters.getToken}`
        }
      })
        .then((response) => {
          this.feedback = "";
          return response;
        })
        .catch((error) => {
          return error.response;
        });
    }
  }
};
</script>
